import { render, staticRenderFns } from "./locationMagtIndex.vue?vue&type=template&id=d5f0a7ec&scoped=true"
import script from "./locationMagtIndex.vue?vue&type=script&lang=js"
export * from "./locationMagtIndex.vue?vue&type=script&lang=js"
import style0 from "./locationMagtIndex.vue?vue&type=style&index=0&id=d5f0a7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f0a7ec",
  null
  
)

export default component.exports